<template>
  <BaseRoundedButton
    :class="[
      $style.icon,
      $style.google
    ]"
    @click="$emit('click')"
  >
    <b-img
      :src="require('@/assets/images/google-logo.svg')"
      :class="$style.img"
    />
  </BaseRoundedButton>
</template>

<script>
import BaseRoundedButton from '@/components/Atoms/BaseRoundedButton'
export default {
  name: 'GoogleIcon',
  components: {
    BaseRoundedButton,
  },
}
</script>

<style module lang="scss">
  .icon {
    transition: background-color .3s ease-in-out;
    margin: 0 .2rem;
    z-index: 2;
  }
  .google {
    border: 1px solid darken(#fff, 10%);
    background: #fff;
    &:hover{
      background: darken(#fff, 3%);
    }
  }
  .img {
    height: 30px;
    width: 30px;
  }
</style>
